import React from "react"
import CookieConsent, { OPTIONS } from "react-cookie-consent"
import { useIntl, FormattedMessage } from "gatsby-plugin-react-intl"
import { Link } from "gatsby"

const Cookies = () => {
  const intl = useIntl()
  return (
    <CookieConsent
      disableStyles={true}
      location={OPTIONS.BOTTOM}
      buttonClasses="carebits-cookie-consent__button"
      containerClasses="carebits-cookie-consent"
      contentClasses="carebits-cookie-consent__content"
      cookieName="CarebitsCookiesConsent"
      buttonText={intl.formatMessage({
        id: "cookie_btnAccept",
        defaultMessage: "Akceptuję",
      })}
    >
      <FormattedMessage
        id="cookie_Message"
        defaultMessage="Ta strona korzysta z ciasteczek aby świadczyć usługi na najwyższym
      poziomie. Dalsze korzystanie oznacza, że akceptujesz naszą "
      />
      <Link to="/privacy-policy">
        <FormattedMessage
          id="cookie_PolicyLink"
          defaultMessage="politykę prywatności"
        />
      </Link>
    </CookieConsent>
  )
}

export default Cookies
